var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mx-auto"},[_c('b-alert',{staticClass:"d-flex justify-content-center p-2 mx-auto",attrs:{"variant":"success","show":""}},[_c('p',{staticClass:"mx-auto"},[_vm._v(" You will be redirected shortly ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }